export default {
    SEARCH_FILTER: 1,
    DATE_FILTER: 2
};
